export class StacksModuleError extends Error {
	readonly retryable = true
	constructor(cause?: unknown) {
		super('Leather failed to load. Retry the signature.')
		this.name = 'StacksModuleError'
		if (cause !== undefined) this.cause = cause
	}
}

export type StacksBundle = {
	showConnect: typeof import('@stacks/connect').showConnect
	openPsbtRequestPopup: typeof import('@stacks/connect').openPsbtRequestPopup
	userSession: InstanceType<typeof import('@stacks/connect').UserSession>
	StacksMainnet: typeof import('@stacks/network').StacksMainnet
}

function moduleDefault<T>(mod: T & { default?: T }): T {
	try {
		if (mod && typeof mod === 'object' && 'default' in mod && mod.default) return mod.default
	} catch {
		return mod
	}
	return mod
}

let pending: Promise<StacksBundle> | null = null

export function resetStacksModuleForTests() {
	pending = null
}

export function loadStacksFrom(
	importConnect: () => Promise<typeof import('@stacks/connect')>,
	importNetwork: () => Promise<typeof import('@stacks/network')>
): Promise<StacksBundle> {
	if (!pending) {
		pending = (async () => {
			const [connectMod, networkMod] = await Promise.all([importConnect(), importNetwork()])
			const connect = moduleDefault(connectMod)
			const network = moduleDefault(networkMod)
			const appConfig = new connect.AppConfig()
			return {
				showConnect: connect.showConnect,
				openPsbtRequestPopup: connect.openPsbtRequestPopup,
				userSession: new connect.UserSession({ appConfig }),
				StacksMainnet: network.StacksMainnet
			}
		})().catch((error) => {
			pending = null
			throw error instanceof StacksModuleError ? error : new StacksModuleError(error)
		})
	}
	return pending
}

export function loadStacks(): Promise<StacksBundle> {
	return loadStacksFrom(
		() => import('@stacks/connect'),
		() => import('@stacks/network')
	)
}

/// Warm the chunk while the tab still matches this deploy. A later signature
/// then uses the cached module instead of fetching it mid-purchase.
export function preloadStacks(): Promise<boolean> {
	return loadStacks().then(
		() => true,
		() => false
	)
}
